/**
 * Get the latest record from an array of records based on date
 * @param {Array} records - Array of records with date field
 * @returns {Object|null} - The record with the most recent date
 */
const getLatestRecord = (records = []) => {
  if (!records || records.length === 0) return null;

  return records.reduce((latest, current) => {
    const currentDate = new Date(current.date).getTime();
    const latestDate = new Date(latest.date).getTime();

    // Skip invalid dates
    if (isNaN(currentDate)) return latest;
    if (isNaN(latestDate)) return current;

    // Return the one with the more recent (later) date
    return currentDate > latestDate ? current : latest;
  });
};

export const getLatestFieldValue = (fieldValues, fieldName) => {
  // Safety check for empty context
  if (!fieldValues || !fieldValues[fieldName]) return null;

  const records = fieldValues[fieldName];
  const record = getLatestRecord(records);

  return record ? {
    value: record.value,
    program: record.program,
    date: record.date
  } : null;
};

export const autoPopulateForm = (fieldValues, fields) => {
  const data = {};
  fields.forEach((field) => {
    const result = getLatestFieldValue(fieldValues, field);
    data[field] = result ? result.value : "";
  });
  return data;
};